<script>
export default {
    name: "SimpleHtmlElement",
    props: ["element"],
    render (createElement) {
        const attributes = [...this.element.attributes];
        const attributeObject = attributes.length > 0? attributes.reduce((acc, cur) => {
            acc[cur.name] = cur.value;
            return acc;
        }, {}) : undefined;

        const classes = this.element.type=="H2"? [...this.element.classes, "title", "is-5"]: [...this.element.classes];
        
        const classObject = classes.length > 0? classes.reduce((acc, cur) => {
            acc[cur] = true;
            return acc;
        }, {}) : undefined;
        
        return createElement(this.element.type, {
            class: classObject,
            attrs: attributeObject,
            domProps: {
                innerHTML: this.element.innerHTML
            }
        })
    }
}
</script>